import { CustomButton } from '@/shared/ui/components';
import { Typography } from 'antd';
import { t } from 'ttag';
import type { SupportModuleCardProps } from './supportModuleCard.types';
import './supportModuleCard.scss';

const { Paragraph } = Typography;

/**
 * Renders one support module as a card with its thumbnail, title and description. Title and description are truncated to one and five lines respectively with the full text kept in a tooltip, and the view button hands the whole module to the caller's view handler.
 *
 * @param supportModule - Support module supplying thumbnail, title and description.
 * @param handleViewClick - Callback receiving the module when the view button is clicked.
 * @returns The support module card.
 */
const SupportModuleCard = ({ supportModule, handleViewClick }: SupportModuleCardProps) => (
  <div className="support-module-card">
    <div>
      <img
        className="support-module-card__thumbnail"
        src={supportModule.thumbnail}
        alt="Thumbnail"
      />
      <div className="support-module-card__title">
        <Paragraph
          ellipsis={{
            rows: 1,
            tooltip: supportModule.title,
          }}
        >
          {supportModule.title}
        </Paragraph>
      </div>
      <div className="support-module-card__description">
        <Paragraph
          ellipsis={{
            rows: 5,
            tooltip: supportModule.description,
          }}
        >
          {supportModule.description}
        </Paragraph>
      </div>
    </div>
    <CustomButton
      style="default"
      type="secondary"
      size="small"
      id="view-btn"
      className="view-btn"
      onClick={() => {
        handleViewClick(supportModule);
      }}
    >
      {t`View`}
    </CustomButton>
  </div>
);

export default SupportModuleCard;
